import React, { FC } from 'react';
import { formatFreeText, formatNumeric } from 'src/front/common/utils/formUtils';
import { FormRow } from 'src/front/components/FormStyles';
import { FormProps } from 'src/front/components/identity/FormProps';
import useDefaultIssueCountry from 'src/front/components/identity/useDefaultIssueCountry';
import ExpiredDate from 'src/front/components/identity/Field/ExpiredDate';
import IssueBy from 'src/front/components/identity/Field/IssueBy';
import IssueCountry from 'src/front/components/identity/Field/IssueCountry';
import IssueDate from 'src/front/components/identity/Field/IssueDate';
import SerialCode from 'src/front/components/identity/Field/SerialCode';
import SerialNumber from 'src/front/components/identity/Field/SerialNumber';

// Миграционная карта
const MigrationCard: FC<FormProps> = ({
  formMethods,
  handleDateChange,
  handleTextChange,
  handleCountryChange,
  countries,
}) => {
  useDefaultIssueCountry(formMethods, countries);
  return (
    <>
      <FormRow>
        <SerialCode
          formatter={formatNumeric}
          formMethods={formMethods}
          max={4}
          min={4}
          onChangeHandler={handleTextChange}
        />
        <SerialNumber
          formatter={formatNumeric}
          formMethods={formMethods}
          max={8}
          min={0}
          onChangeHandler={handleTextChange}
        />
      </FormRow>
      <FormRow>
        <IssueDate formMethods={formMethods} onChangeHandler={handleDateChange} />
        <ExpiredDate formMethods={formMethods} onChangeHandler={handleDateChange} />
      </FormRow>
      <FormRow>
        <IssueBy
          formatter={formatFreeText}
          formMethods={formMethods}
          max={200}
          min={1}
          onChangeHandler={handleTextChange}
        />
        <IssueCountry
          countries={countries}
          formMethods={formMethods}
          onChangeHandler={handleCountryChange}
          disabled
        />
      </FormRow>
    </>
  );
};

export default MigrationCard;
